import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
} from "recharts";
import { Reveal } from "./Reveal";

export const DnaMap = ({ dna = [] }) => {
  const data = dna.map((d) => ({ tag: d.tag, value: d.value }));
  const top = [...dna].sort((a, b) => b.value - a.value).filter((d) => d.value > 0).slice(0, 6);

  return (
    <section
      className="relative bg-[#050505] py-24 md:py-36 px-6 md:px-12 lg:px-24"
      data-testid="trust-dna"
    >
      <Reveal className="max-w-3xl mb-14 md:mb-20">
        <span className="font-mono text-xs tracking-[0.3em] text-[#C48A5E] uppercase">
          04 — İçerik DNA Haritası
        </span>
        <h2 className="mt-5 font-serif text-4xl md:text-6xl text-[#F5F5F0]">
          Stratejinin <span className="italic text-[#C48A5E]">psikolojik dağılımı.</span>
        </h2>
        <p className="mt-6 font-sans text-base md:text-lg leading-relaxed text-[#A3A09A]">
          Tüm içeriklerin müşteri psikolojisindeki ağırlığı. Rastgele değil, tasarlanmış bir denge.
        </p>
      </Reveal>

      <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Reveal className="w-full h-[380px] md:h-[500px] rounded-2xl border border-white/5 bg-[#0F0F0F] p-4">
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart data={data} outerRadius="72%">
              <PolarGrid stroke="rgba(255,255,255,0.08)" />
              <PolarAngleAxis
                dataKey="tag"
                tick={{ fill: "#A3A09A", fontSize: 11, fontFamily: "Space Mono" }}
              />
              <Radar
                dataKey="value"
                stroke="#C48A5E"
                fill="#C48A5E"
                fillOpacity={0.25}
                strokeWidth={2}
              />
            </RadarChart>
          </ResponsiveContainer>
        </Reveal>

        <Reveal delay={0.15} className="space-y-6">
          {top.map((d) => (
            <div key={d.tag} data-testid={`trust-dna-bar-${d.tag}`}>
              <div className="flex items-baseline justify-between mb-2">
                <span className="font-sans text-sm tracking-[0.1em] text-[#F5F5F0] uppercase">
                  {d.tag}
                </span>
                <span className="font-mono text-sm text-[#C48A5E]">%{d.value}</span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-white/5 overflow-hidden">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-[#C48A5E]/60 to-[#C48A5E]"
                  style={{ width: `${d.value}%` }}
                />
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default DnaMap;
